/**
 * Module-level slot for the current OIDC access token.
 *
 * Written by AuthContext when the user's session changes; read by
 * api/client.ts to attach the Bearer header on every request. Kept in its
 * own tiny module so api/client.ts doesn't need to import AuthContext
 * (which pulls in the whole UserManager and its side-effects).
 *
 * NOT for cross-tab or persistent storage — the OIDC library owns that.
 * This slot only mirrors the in-memory current token for synchronous
 * access from non-React code paths.
 */

let currentToken: string | null = null;

export function setAuthToken(token: string | null): void {
  currentToken = token;
}

export function getAuthToken(): string | null {
  return currentToken;
}
